var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("transition", { attrs: { name: "fade-right" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mediumResImagesLoaded < _vm.portfolioImages.length,
                expression: "mediumResImagesLoaded < portfolioImages.length",
              },
            ],
            staticClass: "high-res-images-loader",
          },
          [
            _c("div", { staticClass: "value" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.mediumResImagesLoaded) +
                    "/" +
                    _vm._s(_vm.portfolioImages.length)
                ),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("OF IMAGES")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    Math.round(
                      (_vm.mediumResImagesLoaded / _vm.portfolioImages.length) *
                        100
                    )
                  ) + "%"
                ),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-16 align-items-start",
          attrs: { "data-scroll-container": "" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "row no-gutters align-items-lg-start align-items-end w-100",
              attrs: { "data-scroll-section": "" },
            },
            [
              _c("div", { staticClass: "col-xxl-15" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-change-view ml-auto mt-xxl-0 mt-lg-5",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleMasonryColumns },
                  },
                  [_vm._v("change view")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xxl-15 mt-5" }, [
                _c(
                  "div",
                  {
                    staticClass: "masonry",
                    class: [
                      "columns-" + _vm.masonryColumns,
                      { active: _vm.showMasonry },
                    ],
                  },
                  _vm._l(_vm.portfolioImages, function (image, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        staticClass: "masonry-item",
                        style: { "grid-row-end": "span " + image.low.height },
                        attrs: {
                          "data-fancybox": "gallery",
                          "data-caption": image.high.title,
                          href:
                            _vm.$root.viewport.width > 992
                              ? image.high.src
                              : image.medium,
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "img-medium",
                          attrs: { "data-src": image.medium },
                          on: { load: _vm.showMediumResImage },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "img-loader" }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-low",
                          attrs: { src: image.low.src },
                          on: { load: _vm.onLowResImageLoad },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }